import React from 'react';
import {
  Grid,
  Row,
  Col,
  Panel,
  FormGroup,
  Checkbox,
  Button,
  Radio,
  Table
} from 'react-bootstrap';
import {handleHttpResponse} from '../../lib/Helpers';
import LoggedInUser from '../../lib/LoggedInUser';
import Job from '../../lib/Job';
import { CancelJobModal } from '../../components/Modals';
import Helpers from '../../lib/Helpers.js'

import { RefundAmountModal } from "../../components/Modals.js";

class UserJobsTable extends React.Component {

  getStyles() {
    return {};
  }

  constructor (props) {
    super(props);
    this.state = {
      loading: false
    }
  }

  showRefundAmountModal(title, saveAction) {
    this.refs.refundAmountModal.show(title, saveAction);
  }

  showCancelJobModal(title, saveAction) {
      this.refs.cancelJobModal.show(title, saveAction);
  }

  performJobCancel = (job) => {
    return fetch(Helpers.endpoint("/mark_job_as_canceled"), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        auth_token: LoggedInUser.getInfo().auth_token,
        swipecast_job_id: job.swipecast_job_id
      })
    })
  }

  markAsCanceled = async (job) => {
    this.setState({ loading: true });
    try {
      const update = await this.performJobCancel(job);
      const response = await handleHttpResponse(update);
      window.location.reload();
    } catch (err) {
      this.setState({ loading: false });
      alert(err);
    }
  };

  refundAmount = (job, amount) => {
    return fetch(Helpers.endpoint("/refund_amount"), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        auth_token: LoggedInUser.getInfo().auth_token,
        swipecast_job_id: job.swipecast_job_id,
        amount: amount
      })
    }).then(
      result => result.json()
    ).then(response => {
      window.alert(`Refunded ${parseFloat(response.refunded_amount) * 100}%`);
    });
  };

  getProjects = () => {
    return this.props.jobs
      .map(job => job.project)
      .filter((obj, pos, arr) => {
        return (
          arr
            .map(mapObj => mapObj['swipecast_project_id'])
            .indexOf(obj['swipecast_project_id']) === pos
        );
      });
  };
  getRolesPerProject = project => {
    return this.props.jobs.filter(job => {
      return (
        job.project.swipecast_project_id === project.swipecast_project_id &&
        job.job_type === 'Role'
      );
    }).map(job => new Job(job));
  };
  printTechnicalDetails = (project, job) => {
    return (
      <ul>
        <li>Swipecast Project ID: {project.swipecast_project_id}</li>
        <li>Swipecast Job ID: {job.swipecast_job_id}</li>
      </ul>
    );
  }
  getRoleStatusColor = (job) => {
    switch (job.status) {
      case 'waitingForTalentToApply':
        return 'green';
      case 'completedJob':
        return 'blue';
      case 'expiredJob':
        return '#A62A2A';
      case 'canceledJob':
        return 'red';
      default:
        return '#337ab7';
    }
  }
  renderSingleHire = job_hire => {
    const hire = this.props.talent
      ? job_hire
      : this.props.jobs.filter(job => job.swipecast_job_id === job_hire.swipecast_job_id)[0];

    if (this.props.talent && hire.bookee_swipecast_user_id !== this.props.user.swipecast_user_id)
      return null;

    if (!hire) {
      console.error('Inconsistency', job_hire);
      return;
    }

    let job_charge = null;
    let amount_charged = 0;
    if (hire.job_charges) {
      job_charge = hire.job_charges[0];

      amount_charged = hire.job_charges.reduce((carry, jc) => {
        return carry + ((jc.amount - jc.amount_refunded) / (1 + parseFloat(hire.client_fee) )) / 100
      }, 0);
    }
    return (
      <tr style={{ backgroundColor: '#f7f7f7'}}>
        <td width="20%">
          {hire.bookee_swipecast_user_id && (
            <a href={'/users/' + hire.bookee_swipecast_user_id} target="_blank">
              {
                this.props.talent
                  ? this.props.user.full_name
                  : (
                    hire.bookee
                      ? hire.bookee
                      : `${hire.bookee_swipecast_user_id.substring(0, 16)}`
                  )}
            </a>
          )}
        </td>
        <td width="20%">
          <a
            href={
              `${Helpers.frontendURL}/job/` +
              hire.swipecast_job_id +
              '?share_id=' +
              hire.secret_alias_id
            }
            style={{color:this.getRoleStatusColor(hire)}}
            target="_blank">{hire.status}
          </a>
        </td>
        <td style={{whiteSpace: 'pre-line'}}>
          {hire.ledger && hire.ledger
            .map(entry => {
              return entry.action;
            })
            .join('\n ')}</td>
        <td width="20%">
          {hire.dates
            .map(date => {
              return date;
            })
            .join(', ')}</td>
        <td width="20%">
          {hire.rate + ' ' + hire.frequency}<br/>Total Rate: ${hire.total_rate}
          <br />
          Charged: ${ amount_charged }
          {
            amount_charged > 0 && <button onClick={(event) => {
              event.preventDefault();
              this.refs.refundAmountModal.show(hire);
            }}>{` `}Refund</button>
          }
        </td>
        <td width="20%">
          <ul>
            {
              (hire.status !== 'canceledJob' && hire.status !== 'expiredJob') && (
                <li>
                    <a href="#"
                      style={{color: 'red'}}
                      onClick={() => (window.prompt("Type the word \"cancel\"") === 'cancel' && this.markAsCanceled(hire))}
                    >
                      Cancel
                   </a>
                </li>
              )
            }
            {hire.salesforce_opportunity_link && (
              <li>
                <a href={hire.salesforce_opportunity_link} target="_blank">Salesforce Opportunity</a>
              </li>
            )}
            <li>
                <a href={`${Helpers.frontendURL}/third_party_pay/${hire.secret_alias_id}`} target="_blank">Payment Link</a>
            </li>
            {job_charge && job_charge.stripe_transfer_id && (
              <li>
                <a
                  href={
                    'https://dashboard.stripe.com/' +
                    job_charge.data.destination +
                    '/payouts/' +
                    job_charge.stripe_transfer_id
                  }
                  target="_blank">
                  Bank Transfer Status
              </a>
              </li>
            )}
          </ul>
        </td>
      </tr>
    );
  };

  render() {
    return (
      <div>
        <CancelJobModal
          ref="cancelJobModal"
          buttonText="Close"
        />
        <RefundAmountModal ref="refundAmountModal" saveAction={this.refundAmount} />

        {this.getProjects().map((project) => {
          return (
            <Table bordered condensed style = {{backgroundColor: '#f7f7f7', border: '2px solid #444'}}>
              <thead>
              <tr style={{borderTop: '1px solid #444'}}>
                <td colSpan="2">
                  <b>
                    <a target="_blank" href={`${Helpers.frontendURL}/project/${project.swipecast_project_id}`}>{project.name}</a>
                    {' '}by{' '}
                    <a href={`/users/${project.user.swipecast_user_id}`}>
                      {project.user.full_name.toUpperCase()}
                    </a>
                  </b>
                </td>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td width="25%">Roles</td>
                <td>Hires</td>
              </tr>
              {this.getRolesPerProject(project).map((role) => {
                return (
                  <tr style={{borderTop: '2px solid #444'}}>
                    <td>
                      <ul>
                        <li>
                          Looking For:{` `}
                          <a
                            href={`${Helpers.frontendURL}/job/${role.swipecast_job_id}?share_id=${role.secret_alias_id}`}
                            target="_blank">
                            {role.looking_for}
                          </a>
                        </li>
                        <li>Status: <span style={{ color: this.getRoleStatusColor(role) }}>{role.status}</span></li>
                        <li>Direct Booking: {role.booking ? 'YES' : 'NO'}</li>
                        <li>Job Dates: {role.dates.join(', ')}</li>
                        <li>Total Rate: ${role.total_rate}</li>
                        <li>Last Action: <b>{role.ledger.length > 0 ? role.ledger[role.ledger.length -1].action : 'N/A'}</b></li>
                        {role.salesforce_opportunity_link && (
                          <li>
                            <a href={role.salesforce_opportunity_link} target="_blank">Salesforce Opportunity</a>
                          </li>
                        )}
                        <li>Approved by:<b>{role.approvedBy()}</b></li>
                      </ul>
                      {
                        !!LoggedInUser.getInfo().user.dev && this.printTechnicalDetails(project, role)
                      }
                    </td>
                    <td style={{backgroundColor: (!role.booking && role.job_hires !== undefined && role.job_hires.length === 0) ? '#ececec' : '#f7f7f7', padding: 0}}>
                      <Table bordered style={{minHeight: '180px', margin: '0px'}}>
                        <tbody>
                        {role.booking && this.renderSingleHire(role)}
                        {(!role.booking && role.job_hires !== undefined) &&
                            role.job_hires.map(hire =>
                              this.renderSingleHire(hire))}
                        {!role.booking && role.job_hires.length === 0 && (
                          <tr>
                            <td style={{backgroundColor: '#d7d7d7'}}>
                              {`<< No Hires for this Role >>`}
                            </td>
                          </tr>
                        )}
                        </tbody>
                      </Table>
                    </td>
                  </tr>
                );
              })}
              </tbody>
            </Table>
          );
        })}
      </div>
    );
  }
}

export default UserJobsTable;